module.exports = __webpack_public_path__ + "img/home_background.ae30f28a.jpg";